<template>
  <div class="d_flex flex_direction_col h100">
    <div class="nav_w">
      <el-tabs v-model="activeTab" type="border-card" @tab-click="onTabClick">
        <el-tab-pane :label="isAuction ? '项目信息' : '项目信息'" name="tab1">
          <div class="">
            <!-- 项目信息 -->
            <div
              class="table-info-w fz14 c_1A1A1A d_flex flex_direction_col"
              v-if="projectInfo.targets && projectInfo.targets.length"
            >
              <!-- <CardHead title="基本信息" /> -->
              <div
                class="title_w x_y_center c_1A1A1A font_w_bold"
                style="margin-top: 10px"
              >
                <span class="line" /><span>资产信息</span><span class="line" />
              </div>

              <!-- 标的信息 -->
              <table
                v-if="projectInfo.targets && projectInfo.targets.length"
                border="0"
                cellspacing="10"
              >
                <tr>
                  <td rowspan="40" class="table_title" style="width: 85px">
                    资产信息
                  </td>
                </tr>
                <component
                  :is="projectInfo.tradeKind"
                  :item-detail="projectInfo"
                />
              </table>
            </div>

            <!-- 招标方信息 -->
            <div
              class="table-info-w fz14 c_1A1A1A d_flex flex_direction_col"
              v-if="isSmallmicro"
            >
              <!-- <CardHead title="基本信息" /> -->
              <div
                class="title_w x_y_center c_1A1A1A font_w_bold"
                style="margin-top: 10px"
              >
                <span class="line" /><span>招标方信息</span
                ><span class="line" />
              </div>

              <!-- 招标方信息 -->
              <table border="0" cellspacing="10">
                <tr>
                  <!-- 注意该rowspan="" -->
                  <td rowspan="11" class="table_title" style="width: 85px">
                    招标方
                  </td>
                  <td class="w_td font_w_bold">招标方名称</td>
                  <td class="td_val_2 text_left">
                    {{ itemDetail.project.subject.name }}
                  </td>
                  <td class="font_w_bold">联系人</td>
                  <td class="td_val_2 text_left">
                    {{ itemDetail.project.subject.contact }}
                  </td>
                </tr>
                <tr>
                  <td class="font_w_bold">联系方式</td>
                  <td class="text_left">
                    {{ itemDetail.project.subject.contactWay }}
                  </td>
                  <td class="font_w_bold">联系地址</td>
                  <td class="text_left">
                    {{ itemDetail.project.subject.address }}
                  </td>
                </tr>
              </table>
            </div>

            <!-- 项目信息 -->
            <div class="table-info-w fz14 c_1A1A1A d_flex flex_direction_col">
              <!-- <CardHead title="基本信息" /> -->
              <div
                class="title_w x_y_center c_1A1A1A font_w_bold"
                style="margin-top: 30px"
              >
                <span class="line" /><span>转出信息</span><span class="line" />
              </div>

              <SmallTableInfo v-if="isSmallmicro" :item-detail="itemDetail" />

              <table v-else border="0" cellspacing="10">
                <tr>
                  <td rowspan="25" class="table_title" style="width: 85px">
                    转出信息
                  </td>
                  <td class="w_td font_w_bold">项目名称</td>
                  <td class="max_w_107 text_left">
                    {{ projectInfo.title }}
                  </td>
                  <td class="w_td font_w_bold">项目编号</td>
                  <td class="max_w_107 text_left">
                    {{ projectInfo.projectNo }}
                  </td>
                </tr>
                <tr>
                  <td class="font_w_bold">交易方式</td>
                  <td class="max_w_107 text_left">
                    {{ tradeModeKey[projectInfo.tradeMode] }}
                  </td>
                  <td class="font_w_bold">转出方式</td>
                  <td class="max_w_107 text_left">
                    {{ projectInfo.transferModeName }}
                  </td>
                </tr>
                <tr>
                  <td class="font_w_bold">转出期限</td>
                  <td class="max_w_107 text_left">
                    {{ projectInfo.deadline }}
                    {{ deadlineUnitKey[projectInfo.deadlineUnit] }}
                  </td>
                  <td class="font_w_bold">挂牌价格</td>
                  <td class="max_w_107 text_left">
                    {{ projectInfo.price }}{{ projectInfo.priceUnitDesc }}
                  </td>
                </tr>
                <tr
                  v-if="projectInfo.targets && projectInfo.targets[0].typeName"
                >
                  <td class="font_w_bold">标的类型</td>
                  <td colspan="3" class="text_left">
                    {{ projectInfo.targets[0].typeName }}
                  </td>
                </tr>
                <tr v-if="itemDetail.projectStartAt">
                  <td class="font_w_bold">预计租赁起始日期</td>
                  <td colspan="3" class="text_left">
                    <span>{{
                      formatDate(itemDetail.projectStartAt, "yyyy-MM-dd")
                    }}</span>
                    <span v-show="itemDetail.projectEndAt"> 至 </span>
                    <span v-if="itemDetail.projectEndAt">{{
                      formatDate(itemDetail.projectEndAt, "yyyy-MM-dd")
                    }}</span>
                  </td>
                </tr>

                <tr>
                  <td class="font_w_bold">原承租方是否优先权</td>
                  <td class="max_w_107 text_left">
                    {{ transferPriority(projectInfo.priorityOriginalLessee) }}
                  </td>
                  <td class="font_w_bold">再次转出</td>
                  <td class="max_w_107 text_left">
                    <span v-if="projectInfo.againTransfer">是</span>
                    <span v-else>否</span>
                  </td>
                </tr>
                <tr v-if="projectInfo.negotiationStartTime">
                  <td class="font_w_bold">协商开始时间</td>
                  <td class="max_w_107 text_left">
                    {{ projectInfo.negotiationStartTime }}
                  </td>
                  <td class="font_w_bold">协商截止时间</td>
                  <td class="max_w_107 text_left">
                    {{ projectInfo.negotiationEndTime }}
                  </td>
                </tr>
                <tr v-if="projectInfo.intentionEndTime">
                  <td class="font_w_bold">意向人确认截止时间</td>
                  <td colspan="3" class="text_left">
                    {{ projectInfo.intentionEndTime }}
                  </td>
                </tr>
                <tr v-if="projectInfo.applyEndTime">
                  <td class="font_w_bold">报名截止时间</td>
                  <td colspan="3" class="text_left">
                    {{ projectInfo.applyEndTime }}
                  </td>
                </tr>
                <tr>
                  <td class="font_w_bold">所在区域</td>
                  <td colspan="3" class="text_left">{{ projectInfo.area }}</td>
                </tr>
                <tr>
                  <td class="font_w_bold">详细地址</td>
                  <td
                    colspan="3"
                    class="text_left"
                    :title="projectInfo.address"
                  >
                    {{ projectInfo.address }}
                  </td>
                </tr>
                <tr>
                  <td class="font_w_bold">数量/面积</td>
                  <td class="max_w_107 text_left">
                    {{ projectInfo.quantity }}{{ projectInfo.quantityUnitName }}
                  </td>
                  <td class="font_w_bold">付款方式</td>
                  <td class="max_w_107 text_left">
                    {{ paymentModeKey[projectInfo.paymentMode] }}
                  </td>
                </tr>
                <template
                  v-if="
                    projectInfo.evaluated &&
                    !isEmtry(projectInfo.evaluated.organ)
                  "
                >
                  <tr>
                    <td class="font_w_bold">评估价格</td>
                    <td class="max_w_107 text_left">
                      {{ projectInfo.evaluated.evaluatePrice }}元
                    </td>
                    <td class="font_w_bold">评估机构</td>
                    <td class="max_w_107 text_left">
                      {{ projectInfo.evaluated.organ }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font_w_bold">评估日期</td>
                    <td class="max_w_107 text_left">
                      {{ projectInfo.evaluated.evaluationDate }}
                    </td>
                    <td class="font_w_bold">文件编号</td>
                    <td class="max_w_107 text_left">
                      {{ projectInfo.evaluated.fileNo }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font_w_bold">核准日期</td>
                    <td class="max_w_107 text_left">
                      {{ projectInfo.evaluated.validateDate }}
                    </td>
                    <td class="font_w_bold">核准机构</td>
                    <td class="max_w_107 text_left">
                      {{ projectInfo.evaluated.validateOrgan }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font_w_bold">评估附件</td>
                    <td colspan="3" class="text_left">
                      <template v-if="projectInfo.evaluated.attachments">
                        <div
                          v-for="(item, index) in projectInfo.evaluated
                            .attachments"
                          :key="item.url"
                          style="margin: 5px 0"
                        >
                          <span>附件{{ index + 1 }}：</span>
                          <span
                            class="cursor_pointer c_2CAEFF"
                            @click="downLocalFile(item)"
                            >{{ item.name }}
                          </span>
                          <el-progress
                            v-if="item.downing"
                            :percentage="item.percentage"
                            style="white-space: nowrap"
                          />
                        </div>
                      </template>
                    </td>
                  </tr>
                </template>

                <tr v-if="projectInfo.purpose">
                  <td class="font_w_bold">用 途</td>
                  <td colspan="3" class="text_left">
                    {{ projectInfo.purpose }}
                  </td>
                </tr>
                <tr>
                  <td class="font_w_bold">与转让标的相关的其他情况</td>
                  <td colspan="3" class="text_left">
                    <div v-html="remarkHandle"></div>
                  </td>
                </tr>
                <tr>
                  <td class="font_w_bold">与受让方相关的条件</td>
                  <td colspan="3" class="text_left">
                    <div v-html="transfereeConditionHandle"></div>
                  </td>
                </tr>

                <!-- 竞价规则 -->
                <tr v-if="isAuction">
                  <!-- <td rowspan="20" class="table_title" style="width: 85px">
                    竞价规则
                  </td> -->
                  <td class="w_td font_w_bold">是否缴纳交易保证金</td>
                  <td class="max_w_107 text_left">
                    {{ whether[itemDetail.deposit] }}
                  </td>
                  <td class="w_td font_w_bold">交易保证金</td>
                  <td class="max_w_107 text_left">
                    {{ itemDetail.margin || 0 }}元
                  </td>
                </tr>
                <tr v-if="isAuction">
                  <td class="font_w_bold">竞价方式</td>
                  <td class="max_w_107 text_left">
                    {{ auctionModeKey[itemDetail.auctionMode] }}
                  </td>
                  <td class="font_w_bold">竞价幅度</td>
                  <td class="max_w_107 text_left">
                    {{ itemDetail.auctionRange || 0 }}元
                  </td>
                </tr>
                <tr v-if="isAuction">
                  <td class="font_w_bold">出价次数</td>
                  <td class="max_w_107 text_left">
                    {{ bidCountKey[itemDetail.bidCount] }}
                  </td>
                  <td class="font_w_bold">竞价方向</td>
                  <td class="max_w_107 text_left">
                    {{ directionKey[itemDetail.direction] }}
                  </td>
                </tr>
                <tr v-if="isAuction">
                  <td class="font_w_bold">是否延时</td>
                  <td class="max_w_107 text_left">
                    {{ whether[itemDetail.delay] }}
                  </td>
                  <td class="font_w_bold">延时周期</td>
                  <td class="max_w_107 text_left">
                    {{ itemDetail.delayedMinute }}分钟/次
                  </td>
                </tr>
                <tr v-if="isAuction">
                  <td class="font_w_bold">最大延时次数</td>
                  <td colspan="3" class="text_left">
                    {{ itemDetail.delayedCnt }}次
                  </td>
                </tr>
                <tr v-if="isAuction">
                  <td class="font_w_bold">报名开始时间</td>
                  <td class="max_w_107 text_left">
                    {{ itemDetail.applyStartTime }}
                  </td>
                  <td class="font_w_bold">报名结束时间</td>
                  <td class="max_w_107 text_left">
                    {{ itemDetail.applyEndTime }}
                  </td>
                </tr>
                <tr v-if="isAuction">
                  <td class="font_w_bold">竞价开始时间</td>
                  <td class="max_w_107 text_left">
                    {{ itemDetail.auctionStartTime }}
                  </td>
                  <td class="font_w_bold">竞价结束时间</td>
                  <td class="max_w_107 text_left">
                    {{ itemDetail.auctionEndTime }}
                  </td>
                </tr>

              </table>

              <!-- 账户信息 -->
              <table
                v-if="itemDetail.bankCard && !isRenewal"
                border="0"
                cellspacing="10"
              >
                <tr>
                  <td rowspan="5" class="table_title" style="width: 85px">
                    账户信息
                  </td>
                  <td class="w_td font_w_bold" style="font-size: 16px">
                    账户名称
                  </td>
                  <td
                    class="text_left"
                    style="font-size: 16px; font-weight: bold"
                  >
                    {{ itemDetail.bankCard.accountName }}
                  </td>
                </tr>
                <tr>
                  <td class="font_w_bold" style="font-size: 16px">开户银行</td>
                  <td
                    class="text_left"
                    style="font-size: 16px; font-weight: bold"
                  >
                    {{ itemDetail.bankCard.openBank }}
                  </td>
                </tr>
                <tr>
                  <td class="font_w_bold" style="font-size: 16px">银行账号</td>
                  <td
                    class="text_left"
                    style="font-size: 16px; font-weight: bold"
                  >
                    {{ itemDetail.bankCard.bankCard }}
                  </td>
                </tr>
                <tr>
                  <td class="font_w_bold" style="font-size: 16px">转账备注</td>
                  <td
                    class="text_left"
                    style="font-size: 16px; font-weight: bold"
                  >
                    交易保证金打款时务必注明项目名称
                  </td>
                </tr>
              </table>
            </div>
            <!-- 实景图 -->
            <div class="block-space">
              <!-- <CardHead title="实景图" /> -->
              <div class="title_w x_y_center c_1A1A1A font_w_bold">
                <span class="line" /><span>图片展示</span><span class="line" />
              </div>
              <div
                v-if="projectInfo.realisticImgs.length"
                id="_realisticImgs"
                class="realistic_picture_w d_flex flex_wrap text_center"
              >
                <el-image
                  v-for="(item, index) in projectInfo.realisticImgs"
                  :key="index"
                  class="pic_i"
                  :src="item + '!443'"
                  alt=""
                  :preview-src-list="projectInfo.realisticImgs"
                />
              </div>
            </div>
            <!-- 相关附件 -->
            <div v-if="allOtherAttachs.length" class="block-space">
              <!-- <CardHead title="相关附件" /> -->
              <div class="title_w x_y_center c_1A1A1A font_w_bold">
                <span class="line" /><span>附件下载</span><span class="line" />
              </div>
              <div class="second_tab fz14">
                <div
                  v-for="(item, index) in allOtherAttachs"
                  :key="index"
                  class="attachs_item text_left"
                >
                  <span>附件{{ index + 1 }}：</span>
                  <span
                    class="cursor_pointer c_2CAEFF"
                    @click="downLocalFile(item)"
                    >{{ item.name }}
                  </span>
                  <el-progress
                    v-if="item.downing"
                    :percentage="item.percentage"
                    style="white-space: nowrap"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="!isNotSmallmicro && projectInfo.otherAttachs.length"
              class="block-space"
            >
              <!-- <CardHead title="相关附件" /> -->
              <div class="title_w x_y_center c_1A1A1A font_w_bold">
                <span class="line" /><span>附件下载</span><span class="line" />
              </div>
              <div class="second_tab fz14">
                <div
                  v-for="(item, index) in projectInfo.otherAttachs"
                  :key="index"
                  class="attachs_item text_left"
                >
                  <span>附件{{ index + 1 }}：</span>
                  <span
                    class="cursor_pointer c_2CAEFF"
                    @click="downLocalFile(item)"
                    >{{ item.name }}
                  </span>
                  <el-progress
                    v-if="item.downing"
                    :percentage="item.percentage"
                    style="white-space: nowrap"
                  />
                </div>
              </div>
            </div>
            <!-- 标的视频 -->
            <div v-if="hasVideos" id="tab3" class="block-space">
              <!-- <CardHead title="标的视频" /> -->
              <div class="title_w x_y_center c_1A1A1A font_w_bold">
                <span class="line" /><span>视频展示</span><span class="line" />
              </div>
              <div
                v-for="(item, index) in projectInfo.videos"
                :key="index"
                class="text_center video_i"
                :style="{
                  background: `url('${item.cover}') center 0 no-repeat rgb(0,0,0)`,
                }"
                @mouseenter="onTargetVideoEnter(index)"
                @mouseleave="onTargetVideoLeave"
              >
                <div :id="'targetVideo_' + index" />
              </div>
            </div>
            <!-- 标的位置 -->
            <div
              class="block-space"
              style="margin-top: 30px"
              v-if="itemDetail.precautions"
            >
              <!-- <CardHead title="标的位置" /> -->
              <div class="title_w x_y_center c_1A1A1A font_w_bold">
                <span class="line" /><span>注意事项</span><span class="line" />
              </div>
              <div v-html="itemDetail.precautions"></div>
            </div>
            <!-- 标的位置 -->
            <div v-if="hasLocation" id="tab5" class="block-space">
              <!-- <CardHead title="标的位置" /> -->
              <div class="title_w x_y_center c_1A1A1A font_w_bold">
                <span class="line" /><span>位置信息</span><span class="line" />
              </div>
              <ProjectMap :project="projectInfo" />
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="isAuction" label="交易须知" name="tab4">
          <div v-if="bidding" class="fz14" v-html="bidding.content" />
        </el-tab-pane>

        <el-tab-pane v-if="tradenoticeColumn" label="交易公告" name="tab10">
          <div v-html="tradenoticeColumn.content" />
        </el-tab-pane>
        <el-tab-pane v-if="isAuction" name="tab6">
          <div slot="label">
            <span>出价记录</span>
            <span
              >（<em class="" style="color: #409eff">{{
                itemDetail.biddings.length
              }}</em
              >）</span
            >
          </div>

          <div class="letter_spacing_1" style="margin-top: 20px">
            <div
              class="bc_F2F2F2 c_808080 d_flex text_center fz16"
              style="padding: 17px 0"
            >
              <div style="flex: 0.25">状态</div>
              <div style="flex: 0.25">竞投号</div>
              <div style="flex: 0.25">价格</div>
              <div style="flex: 0.25">出价时间</div>
            </div>
            <div v-if="itemDetail">
              <div
                v-for="(item, index) in itemDetail.biddings"
                :key="item.id"
                class="biddings_w d_flex text_center fz14"
              >
                <div v-if="index === 0" class="cell_item" style="flex: 0.25">
                  <span class="state_text">{{
                    itemDetail.state === 9 ? "成交" : "领先"
                  }}</span>
                </div>
                <div v-else class="cell_item" style="flex: 0.25">
                  <span class="state_text">出局</span>
                </div>
                <div class="cell_item" style="flex: 0.25">
                  {{ item.phone }}
                  <span v-if="item.priority"
                    ><img
                      src="@/assets/images/you.png"
                      style="
                        height: 17px;
                        position: relative;
                        top: 4px;
                        margin-right: 5px;
                      "
                  /></span>
                  <span v-if="item.principal"
                    ><img
                      src="@/assets/images/wei.png"
                      style="height: 17px; position: relative; top: 4px"
                  /></span>
                  <span v-else
                    ><img
                      src="@/assets/images/block.png"
                      style="
                        height: 17px;
                        position: relative;
                        top: 4px;
                        width: 17px;
                      "
                  /></span>
                </div>
                <div class="cell_item" style="flex: 0.25">
                  {{ numTranFloat(item.bidPrice) }}
                </div>
                <div class="cell_item" style="flex: 0.25">
                  {{ item.createdAt }}
                </div>
              </div>
            </div>
            <div
              v-if="itemDetail.biddings && !itemDetail.biddings.length"
              class="x_y_center site_min_h"
            >
              <img src="@/assets/images/empty_icon.png" alt="" />
              <span style="margin: 0 0 0 10px">暂无数据</span>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="selectnoticeColumn" label="遴选公告" name="tab9">
          <div v-html="selectnoticeColumn.content" />
        </el-tab-pane>
        <el-tab-pane v-if="negotiatenoticeColumn" label="协商方案" name="tab11">
          <div v-html="negotiatenoticeColumn.content" />
        </el-tab-pane>
        <el-tab-pane v-if="resultnoticeColumn" label="结果公示" name="tab12">
          <div v-html="resultnoticeColumn.content" />
        </el-tab-pane>
        <el-tab-pane v-if="cnoticeColumn" label="成交公告" name="tab8">
          <div v-html="cnoticeColumn.content" />
        </el-tab-pane>
        <el-tab-pane v-if="tnoticeColumn" label="通知公告" name="tab7">
          <div v-html="tnoticeColumn.content" />
        </el-tab-pane>
        <el-tab-pane
          v-if="costStandardInfo"
          :label="'收费标准' || costStandardInfo.title"
          name="tab13"
        >
          <div class="fz14" v-html="costStandardInfo.content" />
        </el-tab-pane>
      </el-tabs>
    </div>

    <ImportJs
      :src="`${static_resource}/js/oss.js`"
      script-key="oss"
      @loadComplete="ossCompleteFn"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

import construction from "@/components/template/targets/construction.vue";
import farmland from "@/components/template/targets/farmland.vue";
import house from "@/components/template/targets/house.vue";
import operating from "@/components/template/targets/operating.vue";
import resource from "@/components/template/targets/resource.vue";
import forest from "@/components/template/targets/forest.vue";
import wasteland from "@/components/template/targets/wasteland.vue";

import {
  debounce,
  regMobile,
  numTurnText,
  numTranFloat,
  createPlayer,
  filterRepeat,
  formatDate,
  isEmtry,
  findItemByArr,
} from "@/utils";
import { user_playAuth } from "@/api/user";

import ImportJs from "@/components/base/ImportJs.vue";
import ProjectMap from "@/components/template/map/ProjectMap.vue";
import { TradeMode } from "@/enums";
import TradeKindEnum from "@/enums/tradeKindEnum";
import CardHead from "@/components/template/CardHead.vue";
import bus from "@/utils/bus";
import {
  cms_nodeCodeInfo,
  portal_project_notices,
  cms_code_article_info,
} from "@/api/portal.js";
import SmallTableInfo from "@/views/public_0983cc/trade/detail/smallmicro/TableInfo.vue";
import Player from "xgplayer";
import { Events } from "xgplayer";

export default {
  components: {
    ImportJs,
    construction,
    farmland,
    house,
    operating,
    resource,
    forest,
    wasteland,
    ProjectMap,
    CardHead,
    SmallTableInfo,
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      initComplete: false,
      allOtherAttachs: [],

      targetVideoCheck: "pause",
      currentVideoIndex: null, // 当前hover视频索引
      player: null,
      playVideoIndex: null, // 正在播放视频索引

      activeTab: "tab1",
      noticeList: [],
      costStandardInfo: null,
    };
  },
  computed: {
    ...mapGetters([
      "siteInfo",
      "Bucket_pub",
      // 'isMapJsComplete',
      "bidding",
      "tradeModeKey",
      "paymentModeKey",
      "delayKey",
      "whether",
      "auctionModeKey",
      "bidCountKey",
      "directionKey",
      "priceUnitKey",
      "static_resource",
      "deadlineUnitKey",
    ]),
    isEmtry: () => isEmtry,
    formatDate() {
      return function (date, fmt) {
        return formatDate(new Date(date), fmt);
      };
    },
    // 是否小微
    isNotSmallmicro() {
      return this.projectInfo.tradeKind !== TradeKindEnum.SMALLMICRO;
    },
    // 隐藏手机号
    regMobile: function () {
      return function (phone) {
        return regMobile(phone);
      };
    },
    remarkHandle() {
      if (
        this.projectInfo.remark &&
        typeof this.projectInfo.remark === "string"
      ) {
        return this.projectInfo.remark.replace(/\n/g, "<br>");
      }
      return this.projectInfo.remark;
    },
    transfereeConditionHandle() {
      if (
        this.projectInfo.transfereeCondition &&
        typeof this.projectInfo.transfereeCondition === "string"
      ) {
        return this.projectInfo.transfereeCondition.replace(/\n/g, "<br>");
      }
      return this.projectInfo.transfereeCondition;
    },
    // 格式化金额（小数点）
    formatMoney: function () {
      return function (num) {
        return Number(num).toLocaleString();
      };
    },
    // 格式化金额（中文）
    numTurnText: function () {
      return function (num) {
        return numTurnText(num);
      };
    },
    projectInfo() {
      return this.itemDetail?.project || this.itemDetail;
    },

    // 是否包含相关附件
    hasOtherAttachs() {
      return this.projectInfo.otherAttachs?.length;
    },
    // 是否包含视频
    hasVideos() {
      return this.projectInfo.videos?.length;
    },
    // 是否包含位置
    hasLocation() {
      if (this.projectInfo.targets) {
        for (const v of this.projectInfo.targets) {
          if ((v.gpsLat && v.gpsLng) || JSON.parse(v.layer)?.length) {
            return true;
          }
        }
      }
      return false;
    },
    // 是竞价项目
    isAuction() {
      return this.itemDetail.project.tradeMode === TradeMode.AUCTION;
    },
    // 是续约项目
    isRenewal() {
      return (
        this.itemDetail.project.tradeMode === TradeMode.RENEWAL &&
        this.itemDetail.state == 3
      );
    },
    // 是否包含公告
    hasNotice() {
      return this.noticeList.length;
    },
    numTranFloat: function () {
      return function (num) {
        return numTranFloat(num);
      };
    },
    // 是否小微
    isSmallmicro() {
      return this.itemDetail.project.tradeKind === TradeKindEnum.SMALLMICRO;
    },
    // 公示公告节点
    noticeColumn() {
      return findItemByArr(this.siteInfo.nodes, "code", "notice");
    },
    // 通知公告
    tnoticeColumn() {
      return findItemByArr(this.noticeList, "kind", "tnotice");
    },
    // 成交公告
    cnoticeColumn() {
      return findItemByArr(this.noticeList, "kind", "cnotice");
    },
    // 遴选公告
    selectnoticeColumn() {
      return findItemByArr(this.noticeList, "kind", "selectnotice");
    },
    // 交易公告
    tradenoticeColumn() {
      return findItemByArr(this.noticeList, "kind", "tradenotice");
    },
    // 协商公告
    negotiatenoticeColumn() {
      return findItemByArr(this.noticeList, "kind", "negotiatenotice");
    },
    // 结果公示
    resultnoticeColumn() {
      return findItemByArr(this.noticeList, "kind", "resultnotice");
    },

    videoUrl() {
      return this.projectInfo.videos[0]?.url;
    },
  },
  watch: {
    siteInfo: {
      handler(n) {
        if (Object.keys(n).length) {
          this.initBidding();
        }
      },
      immediate: true,
    },
    projectInfo: {
      handler(n) {
        if (Object.keys(n).length) {
          if (!this.isSmallmicro) {
            this.getAllOtherAttachs();
          }
          this.initComplete = true;
        }
      },
      immediate: true,
    },
    "projectInfo.evaluated.attachments": {
      handler(n) {
        if (n?.length) {
          for (const v of n) {
            this.$set(v, "downing", false);
            this.$set(v, "percentage", 0);
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    this.watchPriviewOptionClick();
    this.getProjectNotices();
    this.getCostStandard();
  },
  mounted() {
    if (this.videoUrl) {
      this.initPlayer();
    }
  },
  destroyed() {
    window.onscroll = null;
  },
  methods: {
    ...mapMutations({
      ossCompleteFn: "app/ossCompleteFn",
    }),
    ...mapActions({
      openPreviewFile: "upload/openPreviewFile",
      initBidding: "cache/initBidding",
      downLocalFile: "upload/downLocalFile",
    }),

    onTabClick() {},
    transferPriority(priority) {
      console.log("priority", priority);
      return priority ? "是" : "否";
    },
    // 获取项目公告
    async getProjectNotices() {
      const { data } = await portal_project_notices({
        projectNo: this.itemDetail.project.projectNo,
      });
      this.noticeList = data;
      console.log('this.noticeList',this.noticeList)
    },
    // 获取收费标准
    async getCostStandard() {
      const { data } = await cms_code_article_info({ code: "costStandard" });
      this.costStandardInfo = data;
    },

    // 初始播放
    async initPlayer() {
      this.$nextTick(() => {
        this.player = new Player({
          id: "targetVideo_" + 0,
          url: this.videoUrl,
          height: "427px",
          width: "100%",
        });
        // 播放完毕
        this.player.on(Events.ENDED, (e) => {
          this.$set(this, "targetVideoCheck", "");
        });
      });
    },

    // 关闭播放器
    onClosePlayer() {
      try {
        this.player?.destroy(); // 销毁之前的播放器
        this.player = null;
        this.playVideoIndex = null;
      } catch (err) {
        console.log();
      }
    },
    //
    onTargetVideoEnter(index) {
      this.currentVideoIndex = index;
      console.log("currentVideoIndex", this.currentVideoIndex);
    },
    //
    onTargetVideoLeave() {
      this.currentVideoIndex = null;
    },
    // 获取所有标的附件
    getAllOtherAttachs() {
      for (const v of this.projectInfo?.targets) {
        if (v?.otherAttachs?.length) {
          for (const attach of v.otherAttachs) {
            this.$set(attach, "downing", false);
            this.$set(attach, "percentage", 0);
          }
          this.allOtherAttachs.push(...v?.otherAttachs);
        }
      }
    },
    // 预览文件 click
    onFileClick(file) {
      window.open(file.url, "_blank");
    },
    // 监听图片预览选项click事件
    watchPriviewOptionClick() {
      bus.$on("PREVIEW:OPTION", (tab) => {
        if (["tab3", "tab5"].includes(tab)) {
          this.activeTab = "tab1";
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.nav_w {
}
.nav-list {
  background-color: #f2f2f2;
  .nav-item {
    display: inline-block;
    width: 110px;
    height: 46px;
    line-height: 46px;
    color: #606266;
    padding: 5px 30px;
    text-align: center;
    white-space: nowrap;
  }
}
#_realisticImgs {
  margin-left: -10px;
}
::v-deep {
  .el-tabs__header {
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .el-tabs--border-card {
    box-shadow: none;
  }
  .el-tabs__item {
    height: 45px;
    line-height: 45px;
  }
  .notice-tab {
    .el-tabs__header {
      position: initial;
    }
    .el-tabs__item {
      height: 40px;
      line-height: 40px;
    }
  }
}

::v-deep .leaflet-popup-content-wrapper {
  border-radius: 4px;
  .leaflet-popup-content {
    margin: 10px;
  }
}
::v-deep .leaflet-popup-tip {
  width: 12px;
  height: 12px;
}

.tab_nav_w {
  margin: 0 0 50px 0;
  padding-bottom: 50px;
}

::v-deep .tab_w {
  // width: 876px;
  padding: 0 20px;
  margin: 30px 0;
}
.title_w {
  margin-bottom: 30px;
  font-size: 24px;
  & span {
    &:nth-child(2) {
      margin: 0 10px;
    }
  }
  .line {
    display: inline-block;
    width: 42px;
    height: 2px;
    background: #0983cc;
  }
}

.tab_c_w {
  min-height: 700px;
  padding: 0;
}

::v-deep .table-info-w {
  & > table {
    // width: 876px;
    // border-color: #e6e6e6;

    //标准单元格宽度
    .w_td {
      width: 147px;
    }
    //最大单元格宽度164
    .max_w_164 {
      max-width: 164px;
    }
    //最大单元格宽度210
    .max_w_210 {
      max-width: 210px;
    }
    //最大单元格宽度270
    .max_w_107 {
      max-width: 107px;
    }
    //最大单元格宽度696
    .max_w_696 {
      max-width: 696px;
    }

    &:last-of-type {
      border-bottom: 1px solid #e6e6e6;
      // tr{
      //   &:last-child{
      //     td{
      //       border-bottom: 1px solid #e6e6e6;
      //     }
      //   }
      // }
    }
    tr {
      &:first-child {
        td {
          &:first-child {
            border-left: 1px solid #e6e6e6;
          }
        }
      }
      td {
        word-break: break-word;
        box-sizing: border-box;
        padding: 10px;
        border-top: 1px solid #e6e6e6;
        border-right: 1px solid #e6e6e6;
      }
    }
    .table_title {
      font-weight: bold;
      padding: 0 18px;
      box-sizing: border-box;
      width: 82px;
      line-height: 34px;
      font-size: 18px;
      background: #eaf2fa;
    }
  }
}
.location_w {
  margin: 50px 0 20px 0;
}

.tab_content_w {
  padding: 0 0 20px 0;
}
.second_tab {
  .attachs_item {
    margin-bottom: 5px;
  }
}
.block-space {
  margin: 20px 0;
}
.video_i {
  position: relative;
  margin-bottom: 10px;
  &:last-child {
    margin: 0 auto;
  }
  .video_i_play_btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    z-index: 1;
  }
}

.realistic_picture_w {
  .pic_i {
    flex-basis: 50%;
    margin: 0 0 10px 0;
    padding-left: 10px;
    box-sizing: border-box;
    max-height: 250px;
  }
}

.biddings_w {
  color: #1a1a1a;
  .state_text {
    width: 42px;
    height: 21px;
    padding: 0 3px;
    color: #1a1a1a;
    border: 1px solid #b3b3b3;
  }

  &:nth-child(1) {
    .state_text {
      padding: 2px 5px;
      border: 0;
      color: #fff;
      background-color: #cf3342;
    }
  }

  &:last-child {
    .cell_item {
      border-bottom: 0;
    }
  }
}

.cell_item {
  padding: 14px 0;
  border-bottom: 1px solid #e6e6e6;
}
</style>
